import { createFileRoute } from "@tanstack/react-router"
import IncomingOrdersOverview from "~/components/purchaseOrder/incomingOrders/IncomingOrdersOverview"

export const Route = createFileRoute("/_auth/procurement/incoming-orders/_layout/overview")({
  component: IncomingOrdersOverview,
})
